import { render, staticRenderFns } from "./PostAnalytics.vue?vue&type=template&id=8257a502&scoped=true"
import script from "./PostAnalytics.vue?vue&type=script&lang=js"
export * from "./PostAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PostAnalytics.vue?vue&type=style&index=0&id=8257a502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8257a502",
  null
  
)

export default component.exports